import { AutonomousActivityType } from "protos/atk/enums";
import { Task, TaskDesignation } from "protos/rtc/jobs";
import { resolvedTheme as theme } from "common/theme/tailwind.theme";

interface TaskColors {
  line: string;
  swath: string;
}

// covered: ground the tractor has already worked
interface ActivityPalette {
  covered: TaskColors;
  uncovered: TaskColors;
}

export const ATK_MAP_PALETTE = {
  row: {
    covered: { line: "#55D63D", swath: "#2FA918" },
    uncovered: { line: theme.colors.gray[700], swath: theme.colors.gray[700] },
  },
  headland: {
    covered: { line: "#1B94FF", swath: "#005AAA" },
    uncovered: { line: "#1E4B73", swath: "#235887" },
  },
  turn: {
    covered: { line: "#CCBF33", swath: "#A39929" },
    uncovered: { line: "#6C672D", swath: "#6C672D" },
  },
} satisfies Record<string, ActivityPalette>;

export const getTaskActivity = ({
  metadata,
}: Task): keyof typeof ATK_MAP_PALETTE => {
  switch (metadata?.activityType) {
    case AutonomousActivityType.ACTIVITY_WORKING_HEADLAND: {
      return "headland";
    }
    case AutonomousActivityType.ACTIVITY_WORKING_ROW:
    case AutonomousActivityType.ACTIVITY_WORKING_DIVERT: {
      return "row";
    }
    case undefined:
    case AutonomousActivityType.ACTIVITY_UNSPECIFIED: {
      return metadata?.designation === TaskDesignation.TASK_DESIGNATION_WORK
        ? "row"
        : "turn";
    }
    default: {
      return "turn";
    }
  }
};
